<script>
  let {clickEvent,MenuToggle} = $props()
</script>

<button class={MenuToggle ? "menu-toggle open": "menu-toggle"} aria-label="menutoggle" onclick={clickEvent}>
  <span class="menu-toggle-bar"></span>
</button>


<style lang="scss">

  .menu-toggle {
    cursor: pointer;
    position: relative;
    z-index: 999;
    width: 20px;
    height: 14px;
    appearance: none;
    border: 0;
    position: relative;
    background: transparent;

    &:before {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      background-color: var(--primary-black);
      position: absolute;
      left: 0;
      top: calc(50% - 1px);
      transition: opacity .2s;
    }

    &-bar {
      &:before {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        background-color: var(--primary-black);
        position: absolute;
        left: 0;
        top: 0px;
        transition: transform .2s;
      }

      &:after {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        background-color: var(--primary-black);
        position: absolute;
        left: 0;
        bottom: 0;
        transition: transform .2s;
      }
    }

    &.open {
      &:before {
        opacity: 0;
      }

      .menu-toggle-bar {
        &:before {
          transform: translate(0, 5px) rotate(45deg);
        }

        &:after {
          transform: translate(0, -7px) rotate(-45deg);
        }
      }
    }
  }
</style>
